import axiosInstance from '@/plugins/axios';

// DCTFWeb via IntegraContador (BFF /dctf) — débito/crédito/saldo/DARF/DCOMP por
// competência (mensal + 13º salário). Substitui o fluxo RPA/.dec anterior.
const ServiceDctf = {
  sincronizar: (cnpj, ano, mes) => axiosInstance.post('dctf/sincronizar', { cnpj, ano, mes }),
  search: (body) => axiosInstance.post('dctf/search', body),
  buscarPorId: (id) => axiosInstance.get(`dctf/${id}`),
};

export default ServiceDctf;
